// ==== Плагин: текст в центре круга ====
import { ArcElement, Chart, Plugin } from "chart.js";

export const centerTextPlugin: Plugin<"doughnut"> = {
  id: "centerText",
  beforeDraw(chart: Chart<"doughnut">) {
    const { height, ctx, ...rest } = chart;
    if (!ctx) {
      return;
    }

    const {
      innerLabels,
    }: {
      innerLabels: Array<{ label: string; value: number }>;
    } =
      // @ts-expect-error valid
      rest.config.data.datasets[0].context;

    const meta = chart.getDatasetMeta(0);
    const firstArc = meta.data[0]; // один сектор, из него достаём центр

    const centerX = firstArc.x;
    const centerY = firstArc.y;

    ctx.save();
    ctx.font = `${(height / 25).toFixed(2)}px sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = "#000";

    if (innerLabels.length === 1) {
      ctx.fillText(innerLabels[0].label, centerX, centerY - 10);
      ctx.fillText(`${(innerLabels[0].value / 1000).toFixed(0)}K`, centerX, centerY + 10);
    } else {
      let startY = centerY + innerLabels.length * 10;
      innerLabels.forEach((item) => {
        ctx.fillText(item.label, centerX, startY - 10);
        ctx.fillText(`${(item.value / 1000).toFixed(0)}K`, centerX, startY + 10);
        startY -= 40;
      });
    }

    ctx.restore();
  },
};

// ==== Плагин: текст вокруг круга ====
export const outsideLabelsPlugin: Plugin<"doughnut"> = {
  id: "outsideLabels",
  afterDatasetDraw(chart: Chart<"doughnut">) {
    const { ctx, chartArea, data } = chart;
    const meta = chart.getDatasetMeta(0);
    const radius = (chartArea.right - chartArea.left) / 2;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const usedPositions: number[] = [];
    const minDistance = 16;

    //calc from 100%
    const dataset = data.datasets[0];
    const total = dataset.data.reduce((sum, val) => sum + val, 0);

    meta.data.forEach((arcElement, index) => {
      const arc = arcElement as ArcElement;
      const angle = (arc.startAngle + arc.endAngle) / 2;
      const labelRadius = radius * 0.75; // ближе к кругу
      const x = centerX + Math.cos(angle) * labelRadius;
      let y = centerY + Math.sin(angle) * labelRadius;
      /*const x = centerX + Math.cos(angle) * (radius + 30);
      const y = centerY + Math.sin(angle) * (radius + 30);*/

      // 💡 Корректируем Y, если он слишком близко к другим
      while (usedPositions.some((prevY) => Math.abs(prevY - y) < minDistance)) {
        y += minDistance; // сдвиг вниз
      }

      usedPositions.push(y); // запоминаем позицию

      const labelLine1 = `${data.labels?.[index]}`;

      //calc from 100%
      const rawValue = dataset.data[index] as number;
      const percentage = (rawValue / total) * 100;
      const labelLine2 = `${percentage.toFixed(2)}%`;

      ctx.save();
      ctx.font = "10px sans-serif";
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(labelLine1, x, y - 8);
      ctx.fillText(labelLine2, x, y + 8);
      ctx.restore();
    });
  },
};
